import React from 'react';
import {QuotationRecord, TicketPrint} from "../../../api";
import {BankDetailsCard} from "./BankDetailsCard";



interface ProposalProps {
   ticket:TicketPrint,
  company_name: string;
  company_address: string;
  company_phone: string;
  recipient_company: string;
  recipient_address: string;
  date: string;
  attention_person: string;
  subject: string;
  reference_no: string;
  serial_no: string;
  device_details: string;
  issue: string;
  parts: QuotationRecord[];
  total_cost: number;
  terms: string[];
  from_name: string;
  from_company: string;
}

export const ProposalForReplacement: React.FC<ProposalProps> = ({
  ticket,
  company_name,
  company_address,
  company_phone,
  recipient_company,
  recipient_address,
  date,
  attention_person,
  subject,
  reference_no,
  serial_no,
  device_details,
  issue,
  parts,
  total_cost,
  terms,
  from_name,
  from_company,
}) => {
  return (
      <div style={{fontFamily: 'Arial, sans-serif', fontSize: '14px', padding: '20px', color: '#000'}}>
          <div style={{borderBottom: '2px solid #000', paddingBottom: '10px', marginBottom: '20px'}}>
              <h2>{company_name}</h2>
              <p style={{whiteSpace: 'pre-wrap'}}>{company_address}</p>
              <p><strong>Tel:</strong> {company_phone}</p>
          </div>

          <div style={{marginBottom: '20px'}}>
              <p><strong>To:</strong><br/>
                  {recipient_company}<br/>
                  <span style={{whiteSpace: 'pre-wrap'}}>{recipient_address}</span>
              </p>

              <p><strong>Dated:</strong> {date}</p>
              <p><strong>Kind Attention:</strong> {attention_person}</p>
              <p><strong>Subject:</strong> {subject}</p>
          </div>

          <div style={{marginBottom: '20px'}}>
              <p>
                  <strong>Reference no:</strong> {reference_no}<br/>
                  <strong>Device Serial no:</strong> {serial_no}<br/>
                  <strong>Device Details:</strong> {device_details}<br/>
                  <strong>Issue:</strong> {issue}
              </p>
          </div>

          <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '10px'}}>
              <thead>
              <tr>
                  <th style={{border: '1px solid #333', padding: '8px', backgroundColor: '#f0f0f0'}}>Sr No</th>
                  <th style={{border: '1px solid #333', padding: '8px', backgroundColor: '#f0f0f0'}}>Description</th>
                  <th style={{border: '1px solid #333', padding: '8px', backgroundColor: '#f0f0f0'}}>Unit Cost</th>
              </tr>
              </thead>
              <tbody>
              {parts.map((item, index) => (
                  <tr key={index}>
                      <td style={{border: '1px solid #333', padding: '8px'}}>{index + 1}</td>
                      <td style={{border: '1px solid #333', padding: '8px'}}>
                          {item.description}<br/>
                          {item.part_number || '—'}<br/>
                          GST {item.gst}%
                      </td>
                      <td style={{border: '1px solid #333', padding: '8px'}}>₹{item.final_amount}</td>
                  </tr>
              ))}
              </tbody>
          </table>

          <p className={"text-right"} style={{fontWeight: 'bold', textAlign:"right", marginTop: '10px'}}>Total: ₹{total_cost}</p>
          <h4>Pay to:</h4>
          <table style={{width: '100%', borderCollapse: 'collapse', margin: '10px 0px'}}>

              <tbody>

              <tr>

                  <td style={{border: '1px solid #333', padding: '8px'}}>
                      <BankDetailsCard
                          bankDetails={ticket.organization.bank_details[0]}
                          amount={total_cost}
                          purpose={`${reference_no}`}
                      />


                  </td>
              </tr>

              </tbody>
          </table>


          <div style={{marginBottom: '20px'}}>
              <h4>Terms & Conditions:</h4>
              <ol style={{paddingLeft: '20px', fontSize: '13px'}}>
                  {terms.map((term, idx) => (
                      <li key={idx}>{term}</li>
                  ))}
              </ol>
          </div>

          <div style={{marginTop: '30px'}}>
              <p><strong>From,</strong><br/>
                  {from_name}<br/>
                  {from_company}
              </p>
          </div>
      </div>
  );
};

export default ProposalForReplacement;
